import Controller from "./deductionplans.controller";
import template from "./deductionplans.html";

const deductionplans = {
  template,
  controller: Controller,
};

export default deductionplans;



// WEBPACK FOOTER //
// ./src/pages/deductionplans/deductionplans.component.js